export const Config = {
    "tasks": [
        "Project Meeting", 
        "Tech Development"
    ]
}